import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import WrapperProvider from './modules/WrapperProvider';
import './i18n';
import { datadogRum } from '@datadog/browser-rum';

const datadogConfig = window.MLBBest?.env?.datadog;
if (datadogConfig) {
  datadogRum.init(datadogConfig);
  datadogRum.startSessionReplayRecording();
}

const container = document.getElementById('lari')!;

// Hide until first paint path runs; do not wait on bootstrap CSS — if that import fails or stalls,
// visibility used to stay "hidden" forever (blank screen, no console error from React).
container.style.visibility = 'hidden';

import('best-common-react/lib/styles/bcr.css')
  .then(() => {
    void import('bootstrap/dist/css/bootstrap-grid.css');
    const root = createRoot(container);
    root.render(
      <WrapperProvider>
        <App />
      </WrapperProvider>,
    );
  })
  .catch((err) => {
    console.error('Failed to load base styles', err);
    const root = createRoot(container);
    root.render(
      <WrapperProvider>
        <App />
      </WrapperProvider>,
    );
  })
  .finally(() => {
    container.style.visibility = 'visible';
  });
